import { Injectable } from '@angular/core';

@Injectable()
export class Configuration {
    public dev = 'http://192.168.5.48:8000/';
    public local = 'http://localhost:8000/';
    public LFD = 'http://180.178.132.147:8000/';
    public prod = 'http://34.234.69.234:8000/';
    public url = this.LFD;
    public apptext = 'Location Intelligence';
}


// WEBPACK FOOTER //
// ./src/app/Configuration.ts